import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  institution: {},
  currentEnvironment: {},
  enabledFeatures: {},
  packages: [],
  stream: {},
  course: {},
  entity: {},
  entityUuid: '',
  topics: [],
  topicsMap: {},
  linearTopics: [],
  nextEntity: {},
  continueLearning: {},
  entityCompetency: {},
  competencies: [],
  learnerDashboardState: {},
  learnerDashboardComponents: [],
  learnerEnrollmentData: [],
  channels: [],
  channelUnreadCount: {},
  unreadCountState: 0,
  customBadWords: []
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/dashboard/vuex/index.js